module.exports = __webpack_public_path__ + "static/media/image18.2cc500d0.png";